exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModalFormQbm{width:100%;max-width:650px;height:100vh;max-height:100%;margin:unset;margin-left:auto}.ModalFormQbm .create-dialog-modal-content__body{padding:20px;overflow:hidden;overflow-y:auto;height:calc(100vh - 62px)}.ModalFormQbm .create-dialog-modal-content__body .btn-primary{background-color:#00adff;border:1px solid #00adff;color:#fff;border-radius:20px}.ModalFormQbm .create-dialog-modal-content__body .btn-primary:hover{color:#00adff;background-color:#fff}.ModalFormQbm .create-dialog-modal-content__body .action-save{display:flex;align-items:center;justify-content:center}.ModalFormQuestion{max-width:1100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QbmPage/ModalFormQbm/ModalFormQbm.scss
// module id = 4954
// module chunks = 0